export default __webpack_public_path__ + "static/media/ico-rewards-02.e8f2de25.svg";